import { PublicContextSessionStatus } from 'types/graphql';

export function parseSessionStatus(status: string): PublicContextSessionStatus {
  switch (status) {
    case 'CLAIMED':
      return PublicContextSessionStatus.claimed;
    case 'EXPIRED':
      return PublicContextSessionStatus.expired;
    case 'UNCLAIMED':
      return PublicContextSessionStatus.unclaimed;
    default:
      console.warn(`Unknown session status: ${status}`);
      return PublicContextSessionStatus.unclaimed;
  }
}
